import { useAppDispatch } from '../../../../../hooks/useAppDispatch'
import {
    modifyArrayScalarValues,
    replaceBlockArrayTable,
} from '../../../../../store/actions/configurationActions'
import { useAppSelector } from '../../../../../hooks/useAppSelector'
import { selectRightBar } from '../../../../../store/selectors/rightBarSelector'
import {
    collapseRightBar,
    fullScreenRightBar,
    hideRightBar,
} from '../../../../../store/actions/rightBarActions'
import {
    modifyRuleArrayScalarValues,
    modifyRuleCardConfig,
} from '../../../../../store/actions/ruleCardActions'
import { RightBarButtonsPanel } from '../../../../ui/RightBarButtonsPanel.tsx/RightBarButtonsPanel'

interface Props {
    path: string[]
    invalidRowsRefObj: any
    configStateRefObj: any
    scrollIntoRow: (index: number) => void
    scalarsName?: string
    isRuleCard?: boolean
}

export const TableAdvancedFooter = ({
    path,
    invalidRowsRefObj,
    configStateRefObj,
    scrollIntoRow,
    scalarsName,
    isRuleCard,
}: Props) => {
    const dispatch = useAppDispatch()
    const { fullScreen, isButtonsShakeAnimated } =
        useAppSelector(selectRightBar)

    const handleOnCancel = () => {
        dispatch(hideRightBar())
    }

    const handleOnSave = async () => {
        const isValid = !Object.values(invalidRowsRefObj.current).some(Boolean)
        if (!isValid) {
            const index = configStateRefObj.current.findIndex(
                (item: any) =>
                    item.element_id ===
                    Object.keys(invalidRowsRefObj.current)[0]
            )
            if (index !== -1) scrollIntoRow(index)
            return
        }

        const currentState = configStateRefObj.current
        const scalarPayload = scalarsName
            ? {
                  componentState: {
                      [scalarsName]: currentState.map((el: any) => ({
                          label: el[scalarsName],
                          value: el[scalarsName],
                      })),
                  },
                  name: scalarsName,
                  path,
              }
            : null

        const action = isRuleCard
            ? scalarPayload
                ? modifyRuleArrayScalarValues(scalarPayload)
                : modifyRuleCardConfig({ path, data: currentState })
            : scalarPayload
              ? modifyArrayScalarValues(scalarPayload)
              : replaceBlockArrayTable({
                    path,
                    data: currentState,
                })

        dispatch(action)
        const closeBar = setTimeout(() => handleOnCancel())
        return () => clearTimeout(closeBar)
    }

    const handleFullScreen = () => {
        if (!fullScreen) {
            dispatch(fullScreenRightBar())
        } else {
            dispatch(collapseRightBar())
        }
    }

    return (
        <RightBarButtonsPanel
            onSave={handleOnSave}
            onCancel={handleOnCancel}
            onFullScreen={handleFullScreen}
            isFullScreen={!!fullScreen}
            isButtonsShakeAnimated={!!isButtonsShakeAnimated}
        />
    )
}
